function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { FlexColumn, Icon, usePortal } from "../";
export * from "./small";
export const Modal = ({
  open = false,
  onClose,
  setOpen,
  size = "medium",
  children,
  className,
  ...props
}) => {
  const portal = usePortal(open);

  const handleClose = () => {
    !!onClose && onClose(false);
    !!setOpen && setOpen(false);
  };

  return open && !!portal ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ModalDropShadow, {
    open: open,
    onClick: handleClose,
    className: className
  }, /*#__PURE__*/React.createElement(ModalContainer, _extends({
    size: size,
    onClick: e => e.stopPropagation()
  }, props), /*#__PURE__*/React.createElement(ModalCloseIcon, {
    onClick: handleClose,
    platform: true,
    name: "Close"
  }), !!open && children)), portal) : null;
};
export const ModalDropShadow = styled(FlexColumn)`
  background: rgba(0, 0, 0, 0.38);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all ease 0.3s;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  z-index: 499;
  opacity: ${props => props.open ? 1 : 0};
  visibility: ${props => props.open ? "visible" : "hidden"};
`;
export const ModalContainer = styled(FlexColumn)`
  align-self: center;
  background-color: #fff;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  min-height: ${props => props.theme.modal[props.size].height};
  margin-top: ${props => props.size === "full" ? 0 : "72px"};
  padding: 32px 40px 40px 40px;
  position: relative;
  max-width: ${props => props.theme.modal[props.size].width};
  width: 100%;
  z-index: 500;
`;
export const ModalCloseIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  right: 40px;
  top: 32px;
`;